module.exports = __webpack_public_path__ + "img/supporting_institutions.7a4f3a6d.png";